<template>
  <v-container>
    <h3 class="page-title">場次設定</h3>
    <v-row>
      <v-col cols="6" sm="2">
        <v-autocomplete
          v-model="selected.行政區"
          outlined
          :items="衛生所"
          label="負責衛生所"
          dense
          hide-details
          :disabled="!!this.$store.state.user.行政區"
        ></v-autocomplete>
      </v-col>
      <v-col cols="6" sm="2">
        <v-autocomplete
          v-model.number="selected.年度"
          :items="年度"
          label="年度"
          outlined
          dense
          hide-details
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field
          v-model="keyword"
          label="關鍵字"
          outlined
          dense
          hide-details
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="3">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRange.start"
              label="開始日期"
              append-icon="mdi-calendar"
              outlined
              dense
              hide-details
              clearable
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateRange.start"
            no-title
            @input="startDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="6" sm="3">
        <v-menu
          v-model="endDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRange.end"
              label="結束日期"
              append-icon="mdi-calendar"
              outlined
              dense
              hide-details
              clearable
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dateRange.end"
            no-title
            @input="endDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="12" class="d-flex justify-end">
        <v-btn class="mr-3" color="warning" text @click="downloadSample()">
          批次範例
        </v-btn>
        <v-btn class="mr-3" color="warning" @click="$refs.uploader.click()">
          批次匯入
        </v-btn>

        <input ref="uploader" class="d-none" type="file" @change="upload" />
        <v-btn class="mr-3" color="info" @click="exportSections">匯出</v-btn>
        <v-btn color="primary" @click="create">新增</v-btn>
      </v-col>
    </v-row>
    <div class="mt-4">
      <div v-if="selectedSections.length > 0" class="mb-3">
        <v-alert type="info" dense class="mb-2">
          已選取 {{ selectedSections.length }} 個場次
        </v-alert>
        <div class="mb-2">
          <v-btn
            color="primary"
            small
            @click="batchUpdateStatus(true)"
            class="mr-2"
          >
            批次開放 ({{ selectedSections.length }})
          </v-btn>
          <v-btn
            color="warning"
            small
            @click="batchUpdateStatus(false)"
            class="mr-2"
          >
            批次暫停 ({{ selectedSections.length }})
          </v-btn>
          <v-btn color="error" small @click="batchDeleteSections" class="mr-2">
            批次刪除 ({{ selectedSections.length }})
          </v-btn>
          <v-btn color="secondary" small @click="clearSelection">
            清除選取
          </v-btn>
        </div>
      </div>

      <v-data-table
        v-model="selectedSections"
        :headers="headers"
        :items="filterSections"
        item-key="_id"
        show-select
        no-data-text="尚無場次"
        :mobile-breakpoint="0"
        :footer-props="{
          itemsPerPageText: '每頁幾筆',
          itemsPerPageOptions: [10, 30, -1],
        }"
      >
        <template v-slot:item.篩檢項目="{ item }">
          {{ mapItems(item.篩檢項目).join(",") }}
        </template>
        <template v-slot:item.整合式篩檢="{ item }">
          <v-icon large v-if="item.整合式篩檢">mdi-hospital-marker</v-icon>
        </template>
        <template v-slot:item.reserveListMailEnabled="{ item }">
          {{ item.reserveListMailEnabled ? "啟用" : "停用" }}
        </template>
        <template v-slot:item.開始時間="{ item }">
          {{ item.開始時間 }}~{{ item.結束時間 }}
        </template>
        <template v-slot:item.enable="{ item }">
          {{ item.enable ? "開放" : "暫停" }}
        </template>
        <template v-slot:item.動作="{ item }">
          <v-btn
            small
            text
            color="primary"
            @click="update(item)"
            :disabled="item.人數上限 <= item.已配發"
            >修改</v-btn
          >
          <v-btn
            small
            text
            color="error"
            @click="remove(item)"
            :disabled="isDeleteDisabled(item)"
            >刪除</v-btn
          >
        </template>
      </v-data-table>
    </div>
    <sectionDialog
      v-if="dialog"
      v-model="dialog"
      :theSection="selected.section"
      @load="load"
    ></sectionDialog>
    <v-dialog v-if="previewDialog" v-model="previewDialog">
      <v-card>
        <v-card-title>批次匯入預覽</v-card-title>
        <v-card-text class="pt-2">
          <div v-for="(row, n) in importRows" :key="n">
            <v-row align="center">
              <v-col cols="1">
                <v-text-field
                  v-model="row.行政區"
                  outlined
                  label="行政區"
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-text-field
                  v-model="row.年度"
                  outlined
                  label="年度"
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <v-text-field
                  v-model="row.日期"
                  outlined
                  label="日期"
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-text-field
                  v-model="row.開始時間"
                  outlined
                  label="開始時間"
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-text-field
                  v-model="row.結束時間"
                  outlined
                  label="結束時間"
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-text-field
                  v-model="row.人數上限"
                  outlined
                  label="人數上限"
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <v-text-field
                  v-model="row.地點"
                  outlined
                  label="地點"
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.enable"
                  label="開放"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.成健"
                  label="成健"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.BC肝"
                  label="BC肝"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.口腔"
                  label="口腔"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.子抹"
                  label="子抹"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.乳攝"
                  label="乳攝"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.大腸"
                  label="大腸"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.LDCT"
                  label="LDCT"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.HPV"
                  label="HPV"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.胃篩"
                  label="胃篩"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.篩檢項目.ICOPE"
                  label="ICOPE"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.整合式篩檢"
                  label="整合式篩檢"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.顯示問卷"
                  label="顯示問卷"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="auto">
                <v-checkbox
                  class="mt-0 pt-0"
                  v-model="row.reserveListMailEnabled"
                  label="啟用寄送預約清冊"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="previewDialog = false"> 關閉 </v-btn>
          <v-btn color="primary" @click="importList"> 確定匯入 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { 行政區 } from "@/libs/const";
import dayjs from "dayjs";
import downloadCsv from "download-csv";
import sectionDialog from "@/components/Section/sectionDialog";
import * as XLSX from "xlsx/xlsx.mjs";

const all行政區 = {
  text: "全部",
  value: null,
};
const 年度 = dayjs().get("year") - 1911;
export default {
  name: "Section",
  components: { sectionDialog },
  data: () => ({
    dialog: false,
    startDateMenu: false,
    endDateMenu: false,
    keyword: null,
    dateRange: {
      start: null,
      end: null,
    },
    previewDialog: false,
    importRows: [],
    sections: [],
    selectedSections: [],
    headers: [
      { text: "行政區", value: "行政區" },
      { text: "地點", value: "地點" },
      { text: "日期", value: "日期" },
      { text: "時間", value: "開始時間" },
      { text: "人數上限", value: "人數上限", sortable: false },
      { text: "整合式篩檢", value: "整合式篩檢" },
      { text: "啟用寄送預約清冊", value: "reserveListMailEnabled", sortable: false },
      { text: "篩檢項目", value: "篩檢項目" },
      { text: "已預約", value: "已預約" },
      { text: "狀態", value: "enable", sortable: false },
      { text: "", value: "動作", sortable: false },
    ],
    selected: {
      section: {},
      行政區: all行政區,
      年度,
    },
  }),
  computed: {
    filterSections() {
      let sections = this.sections;

      // 關鍵字過濾
      if (this.keyword) {
        sections = sections.filter((r) => r.地點.includes(this.keyword));
      }

      // 日期範圍過濾
      if (this.dateRange.start || this.dateRange.end) {
        sections = sections.filter((section) => {
          const sectionDate = dayjs(section.日期).format("YYYY-MM-DD");

          // 如果只有開始日期
          if (this.dateRange.start && !this.dateRange.end) {
            return sectionDate >= this.dateRange.start;
          }

          // 如果只有結束日期
          if (!this.dateRange.start && this.dateRange.end) {
            return sectionDate <= this.dateRange.end;
          }

          // 如果兩個日期都有
          if (this.dateRange.start && this.dateRange.end) {
            return (
              sectionDate >= this.dateRange.start &&
              sectionDate <= this.dateRange.end
            );
          }

          return true;
        });
      }

      return sections;
    },
    衛生所() {
      let place = 行政區.map((v) => ({
        text: v + "衛生所",
        value: v,
      }));
      place.unshift(all行政區);
      return place;
    },
    年度() {
      let years = [年度 + 1];
      for (let n = 0; n <= 3; n++) {
        years.push(年度 - n);
      }
      return years;
    },
  },
  async created() {
    if (this.$store.state.user.行政區) {
      this.selected.行政區 = this.衛生所.find(
        (row) => row.value == this.$store.state.user.行政區
      );
    }
    await this.load();
  },
  methods: {
    isManagerRole() {
      return this.$store.state.user.角色 === "管理者";
    },
    hasBooking(section) {
      return section.人數上限 <= section.已配發;
    },
    canDeleteByDate(section) {
      if (this.isManagerRole()) return true;
      return dayjs(section.日期).isAfter(dayjs(), "day");
    },
    isDeleteDisabled(section) {
      return this.hasBooking(section) || !this.canDeleteByDate(section);
    },
    async upload(e) {
      let file = e.target.files[0];
      let data = await file.arrayBuffer();
      let workbook = XLSX.read(data);
      let worksheet = workbook.Sheets[workbook.SheetNames[0]];
      let importSection = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
      });

      importSection = importSection.map((o) => {
        o.開始時間 = dayjs(`${o.日期} ${o.開始時間}`).format("HH:mm");
        o.結束時間 = dayjs(`${o.日期} ${o.結束時間}`).format("HH:mm");
        o.篩檢項目 = {
          成健: o.成健 == "1",
          BC肝: o.BC肝 == "1",
          口腔: o.口腔 == "1",
          子抹: o.子抹 == "1",
          乳攝: o.乳攝 == "1",
          大腸: o.大腸 == "1",
          LDCT: o.LDCT == "1",
          HPV: o.HPV == "1",
          胃篩: (o.胃篩 || o.胃癌) == "1",
          ICOPE: o.ICOPE == "1",
        };
        o.enable = o.開放預約 == "1";
        o.整合式篩檢 = o.整合式篩檢 == "1";
        o.顯示問卷 = o.顯示問卷 == "1";
        o.reserveListMailEnabled =
          (o.啟用寄送預約清冊 !== undefined
            ? o.啟用寄送預約清冊
            : o.截止寄清冊) == "1";
        o.年度 = parseInt(o.年度);
        return _.pick(o, [
          "年度",
          "人數上限",
          "行政區",
          "enable",
          "日期",
          "開始時間",
          "結束時間",
          "地點",
          "篩檢項目",
          "整合式篩檢",
          "顯示問卷",
          "reserveListMailEnabled",
        ]);
      });

      importSection = _.filter(
        importSection,
        (o) =>
          !!o.行政區 &&
          !!o.日期 &&
          !!o.地點 &&
          !!o.開始時間 &&
          !!o.結束時間 &&
          !!o.日期
      );

      importSection = importSection.map((o) => {
        if (o.日期.includes("/")) {
          let [mm, dd, yy] = o.日期.split("/");
          if (dd.length <= 2) {
            o.日期 = `20${yy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
          }
        }
        o.開始時間 = o.開始時間.replace("：", ":");
        o.結束時間 = o.結束時間.replace("：", ":");
        return o;
      });

      this.importRows = importSection;
      this.previewDialog = true;
    },
    mapItems(obj) {
      return Object.keys(_.pickBy(obj, (o) => o));
    },
    exportSections() {
      let data = this.sections.map((row) => {
        row.enable = row.enable ? "啟用" : "暫停";
        row.篩檢項目e = `"${this.mapItems(row.篩檢項目).join(",")}"`;
        return _.pick(row, [
          "行政區",
          "地點",
          "日期",
          "開始時間",
          "人數上限",
          "篩檢項目e",
          "已預約",
          "enable",
        ]);
      });

      downloadCsv(
        data,
        { 開始時間: "時間", enable: "狀態" },
        `${this.selected.行政區?.text || "全部"} ${
          this.selected.年度
        } 年度場次資料`
      );
    },

    async create() {
      this.selected.section = {
        年度,
        人數上限: 0,
        reserveListMailEnabled: false,
        篩檢項目: {
          成健: false,
          BC肝: false,
          子抹: false,
          大腸: false,
          口腔: false,
          乳攝: false,
          LDCT: false,
          HPV: false,
          胃篩: false,
          ICOPE: false,
        },
      };

      this.dialog = true;
    },
    async remove(section) {
      if (!this.canDeleteByDate(section)) {
        this.$toast.error("今天（含）以前場次不可刪除");
        return;
      }
      if (this.hasBooking(section)) {
        this.$toast.error("此場次已有預約，無法刪除");
        return;
      }
      if (confirm("確定刪除此場次？")) {
        try {
          await this.axios.delete(`/dashboard/section/${section._id}`);
          this.dialog = false;
          this.$toast.success("刪除成功");
          this.load();
        } catch (e) {
          this.$toast.error("刪除失敗");
        }
      }
    },
    async update(section) {
      if (!section.篩檢項目) {
        section.篩檢項目 = {
          成健: true,
          BC肝: true,
          子抹: true,
          大腸: true,
          口腔: true,
          乳攝: true,
        };
      }
      // 補齊新增加的篩檢項目鍵名（若不存在則預設為 false）
      if (section.篩檢項目.LDCT === undefined) section.篩檢項目.LDCT = false;
      if (section.篩檢項目.HPV === undefined) section.篩檢項目.HPV = false;
      if (section.篩檢項目.胃篩 === undefined) section.篩檢項目.胃篩 = false;
      if (section.篩檢項目.ICOPE === undefined) section.篩檢項目.ICOPE = false;
      if (section.reserveListMailEnabled === undefined) {
        section.reserveListMailEnabled = false;
      }
      this.selected.section = section;
      this.dialog = true;
    },
    async load() {
      if (
        this.selected.行政區 instanceof Object &&
        !this.selected.行政區.value
      ) {
        this.selected.行政區 = null;
      }
      let params = {
        年度: this.selected.年度,
        行政區: this.selected.行政區?.value || this.selected.行政區,
      };
      let sections = (
        await this.axios.get("/dashboard/section", {
          params,
        })
      ).data;
      this.sections = _.orderBy(sections, ["日期", "時間"], ["desc", "asc"]);
    },
    async importList() {
      try {
        await this.axios.post("/dashboard/section", this.importRows);
        this.previewDialog = false;
        this.$toast.success("匯入完成");
        await this.load();
      } catch (e) {}
    },
    downloadSample() {
      window.location = "/場次批次匯入檔.xlsx";
    },
    async batchUpdateStatus(status) {
      if (this.selectedSections.length === 0) {
        this.$toast.info("請先選取場次");
        return;
      }

      try {
        const statusText = status ? "開放" : "暫停";
        if (
          confirm(
            `確定將選取的 ${this.selectedSections.length} 個場次設為${statusText}嗎？`
          )
        ) {
          // 批次更新狀態
          const promises = this.selectedSections.map((section) =>
            this.axios.post(`/dashboard/section`, {
              _id: section._id,
              enable: status,
            })
          );

          await Promise.all(promises);
          this.$toast.success(
            `已成功${statusText} ${this.selectedSections.length} 個場次`
          );
          this.clearSelection();
          await this.load();
        }
      } catch (error) {
        this.$toast.error("批次更新失敗");
      }
    },
    async batchDeleteSections() {
      if (this.selectedSections.length === 0) {
        this.$toast.info("請先選取場次");
        return;
      }

      const hasPastOrTodaySections = this.selectedSections.some(
        (section) => !this.canDeleteByDate(section)
      );
      if (hasPastOrTodaySections) {
        this.$toast.error("選取項目包含今天（含）以前場次，無法刪除");
        return;
      }

      const hasBookings = this.selectedSections.some((section) =>
        this.hasBooking(section)
      );
      if (hasBookings) {
        this.$toast.error("部分場次已有預約，無法刪除");
        return;
      }

      try {
        if (
          confirm(
            `確定刪除選取的 ${this.selectedSections.length} 個場次嗎？此操作無法復原！`
          )
        ) {
          // 批次刪除
          const promises = this.selectedSections.map((section) =>
            this.axios.delete(`/dashboard/section/${section._id}`)
          );

          await Promise.all(promises);
          this.$toast.success(
            `已成功刪除 ${this.selectedSections.length} 個場次`
          );
          this.clearSelection();
          await this.load();
        }
      } catch (error) {
        this.$toast.error("批次刪除失敗");
      }
    },
    clearSelection() {
      this.selectedSections = [];
    },
    clearDateRange() {
      this.dateRange.start = null;
      this.dateRange.end = null;
    },
  },
  watch: {
    "selected.行政區"() {
      this.load();
    },
    "selected.年度"() {
      this.load();
    },
  },
};
</script>

<style lang="scss" scoped></style>
